import React from 'react';
import { PropTypes } from 'prop-types';
import { FastField } from 'formik';
import TextInput from './TextInput';

const FastFieldTextInput = ({
  name,
  label,
  normalize,
  maxLength,
  width,
  type,
  tabTo,
  id,
  autoFocus,
  handleOnBlur,
  ...props
}) => (
  <FastField
    name={name}
    id={id || name}
    render={({ field, form }) => (
      <TextInput
        {...field}
        error={form.touched[name] && form.errors[name]}
        label={label}
        onBlur={handleOnBlur || field.onBlur}
        tabTo={tabTo}
        width={width}
        normalize={normalize}
        maxLength={maxLength}
        type={type}
        autoFocus={autoFocus}
        {...props}
      />
    )}
  />
);

FastFieldTextInput.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  type: PropTypes.string,
  tabTo: PropTypes.string,
  label: PropTypes.string.isRequired,
  normalize: PropTypes.string,
  maxLength: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  autoFocus: PropTypes.bool,
  handleOnBlur: PropTypes.func,
};

FastFieldTextInput.defaultProps = {
  normalize: '',
  type: null,
  tabTo: null,
  id: null,
  maxLength: null,
  width: null,
  autoFocus: false,
  handleOnBlur: null,
};

export default FastFieldTextInput;
